import { SDK_STREAM_TIMEOUT_MS } from '@repo/config';
import { postRawRequest } from '../../httpClient';
import type { IMineGrammarCollectionV1Params } from './mine-grammar-collection-v1-request';

export async function mineGrammarCollectionV1Api({
  collectionId,
  force,
}: IMineGrammarCollectionV1Params): Promise<Response> {
  return postRawRequest({
    path: `/sys/grammar/v1/collections/${collectionId}/mine${force ? '?force=true' : ''}`,
    options: { timeout: SDK_STREAM_TIMEOUT_MS },
  });
}
